export const normalizePrice = price => {
  let result = Number(price).toFixed(2).toString();
  let x = result.split(".");
  let x1 = x[0];
  let x2 = "";

  if (x.length > 1 && x[1] !== "00") {
    x2 = "." + x[1];
  }

  let rgx = /(\d+)(\d{3})/;

  while (rgx.test(x1)) {
    x1 = x1.replace(rgx, "$1 $2");
  }

  return x1 + x2;
};

// Код туркменского в приложении и в moment расходится: у нас tm, в moment — tk.
const momentLangCodes = { tm: "tk" };

export const parserLangCode = language => {
  return momentLangCodes[language] || language;
};

export const paramsToObject = entries => {
  const result = {};

  for (const [key, value] of entries) {
    result[key] = value;
  }

  return result;
};

export const paramsToArrayObject = entries => {
  const result = [];

  for (const [key, value] of entries) {
    result.push({ key, value });
  }

  return result;
};

export const objectsToParams = objects => {
  if (objects.length > 0) {
    let params = "";

    objects.forEach((value, index) => {
      if (index === 0) {
        params = `?${value.key}=${value.value}`;
      } else {
        params = `${params}&${value.key}=${value.value}`;
      }
    });

    return params;
  } else {
    return window.location.pathname;
  }
};

export const noun = (count, first, second, third) => {
  if (+count === 1) {
    return first;
  }

  if (+count > 1 && +count < 5) {
    return second;
  }

  if (+count === 0 || +count >= 5) {
    return third;
  }
};

export const getCalendarPriceNormalized = price => {
  if (price > 1000000) {
    const millions = price / 1000000;
    return `${Math.round(millions * 100) / 100} M`;
  }

  return `${normalizePrice(price)}`;
};

/**
 * Копирование в буфер обмена. navigator.clipboard живёт только в защищённом
 * контексте (https или localhost) и есть не во всех браузерах, поэтому на случай
 * отказа остаётся старый приём со скрытым textarea и execCommand.
 * Возвращает признак успеха, чтобы вызывающий не показывал «Скопировано» впустую.
 */
export const copyToClipboard = async text => {
  if (!text) return false;

  if (navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(text);

      return true;
    } catch (error) {
      // Браузер мог отказать в доступе — пробуем запасной путь ниже.
    }
  }

  const textarea = document.createElement("textarea");

  textarea.value = text;
  textarea.setAttribute("readonly", "");
  // Убираем из потока и с экрана, но оставляем доступным для выделения.
  textarea.style.position = "fixed";
  textarea.style.top = "-9999px";

  document.body.appendChild(textarea);
  textarea.select();

  let isCopied = false;

  try {
    isCopied = document.execCommand("copy");
  } catch (error) {
    isCopied = false;
  }

  document.body.removeChild(textarea);

  return isCopied;
};

/** Правила приходят как текст с переносами, но рендерятся через innerHTML.
 *  Для копирования берём именно текст: и разметку снимет, и сущности раскодирует. */
export const htmlToPlainText = html => {
  if (!html) return "";

  const holder = document.createElement("div");

  holder.innerHTML = html;

  return holder.textContent || "";
};
